module.exports = __webpack_public_path__ + "static/citrix-2f70b2ce9b9115d386e492e183ebf9e7.svg";